<template>
  <div
    :id="`c-switcher-${_uid}`"
    class="c-switcher-width-inherit"
    :class="{ 'c-switcher-width-inherit-cursor': type === 'checkbox-icon', 'c-switcher-invalid': invalid }"
  >
    <label
      v-if="type !== 'group'"
      class="c-switcher"
      :class="{
        'c-switcher_checkbox': type === 'checkbox',
        'c-switcher_checkbox_type_icon': type === 'checkbox-icon',
        'c-switcher_disabled': disabled,
      }"
      @click="toggle"
      @mousedown="mousedown"
    >
      <div v-if="!type" class="c-switcher-indicator" :class="{ 'c-switcher-indicator_active': localValue }">
        <div class="c-switcher-indicator-circle"></div>
      </div>

      <input
        v-if="(type === 'checkbox' || type === 'checkbox-icon') && !multi"
        v-model="localValue"
        type="checkbox"
        class="c-switcher-input"
      />

      <input
        v-if="(type === 'checkbox' || type === 'checkbox-icon') && multi"
        v-model="internalChecked"
        type="checkbox"
        class="c-switcher-input"
        :value="checked"
      />

      <div v-if="type === 'checkbox'" class="c-switcher-checkbox">
        <svg v-if="middlePosition" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect width="18" height="18" rx="3" fill="#0066FF"/>
          <rect x="6" y="6" width="6" height="6" rx="1" fill="white"/>
        </svg>
        <svg
          v-else
          class="c-switcher-checkbox-icon c-switcher-checkbox-icon_check"
          width="11"
          height="8"
          viewBox="0 0 11 8"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.29312 7.6838C2.90259 7.29327 2.90259 6.66011 3.29312 6.26958L8.29712 1.26555C8.68764 0.875025 9.32081 0.875025 9.71133 1.26555C10.1019 1.65607 10.1019 2.28924 9.71133 2.67976L4.70733 7.6838C4.31681 8.07432 3.68364 8.07432 3.29312 7.6838Z"
          />
          <path
            d="M4.70733 7.6838C5.09786 7.29327 5.0978 6.66011 4.70727 6.26958L1.73445 3.29679C1.34393 2.90626 0.710761 2.90626 0.320237 3.29679C-0.0702873 3.68731 -0.0702873 4.32048 0.320237 4.711L3.29312 7.6838C3.68364 8.07432 4.31681 8.07432 4.70733 7.6838Z"
          />
        </svg>
      </div>

      <div v-if="type === 'checkbox-icon'" class="c-switcher_checkbox_type_icon_item">
        <svg
          class="c-switcher_checkbox_type_icon_item_svg"
          fill="none"
          :class="{
            'c-switcher_checkbox_type_icon_disabled': disabled,
            'c-switcher_checkbox_type_icon_active': localValue,
          }"
          width="18"
          height="14"
          viewBox="0 0 18 14"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7071 2.29289C11.3166 1.90237 10.6834 1.90237 10.2929 2.29289C9.90237 2.68342 9.90237 3.31658 10.2929 3.70711L11.7071 2.29289ZM13 5L12.2929 5.70711C12.6834 6.09763 13.3166 6.09763 13.7071 5.70711L13 5ZM17.7071 1.70711C18.0976 1.31658 18.0976 0.683417 17.7071 0.292893C17.3166 -0.0976311 16.6834 -0.0976311 16.2929 0.292893L17.7071 1.70711ZM11.7071 10.2929C11.3166 9.90237 10.6834 9.90237 10.2929 10.2929C9.90237 10.6834 9.90237 11.3166 10.2929 11.7071L11.7071 10.2929ZM13 13L12.2929 13.7071C12.6834 14.0976 13.3166 14.0976 13.7071 13.7071L13 13ZM17.7071 9.70711C18.0976 9.31658 18.0976 8.68342 17.7071 8.29289C17.3166 7.90237 16.6834 7.90237 16.2929 8.29289L17.7071 9.70711ZM1.70711 10.2929C1.31658 9.90237 0.683417 9.90237 0.292893 10.2929C-0.0976311 10.6834 -0.0976311 11.3166 0.292893 11.7071L1.70711 10.2929ZM3 13L2.29289 13.7071C2.68342 14.0976 3.31658 14.0976 3.70711 13.7071L3 13ZM7.70711 9.70711C8.09763 9.31658 8.09763 8.68342 7.70711 8.29289C7.31658 7.90237 6.68342 7.90237 6.29289 8.29289L7.70711 9.70711ZM1.29289 4.29289C0.902369 4.68342 0.902369 5.31658 1.29289 5.70711C1.68342 6.09763 2.31658 6.09763 2.70711 5.70711L1.29289 4.29289ZM6.70711 1.70711C7.09763 1.31658 7.09763 0.683417 6.70711 0.292893C6.31658 -0.0976311 5.68342 -0.0976311 5.29289 0.292893L6.70711 1.70711ZM5.29289 5.70711C5.68342 6.09763 6.31658 6.09763 6.70711 5.70711C7.09763 5.31658 7.09763 4.68342 6.70711 4.29289L5.29289 5.70711ZM2.70711 0.292893C2.31658 -0.0976311 1.68342 -0.0976311 1.29289 0.292893C0.902369 0.683417 0.902369 1.31658 1.29289 1.70711L2.70711 0.292893ZM10.2929 3.70711L12.2929 5.70711L13.7071 4.29289L11.7071 2.29289L10.2929 3.70711ZM13.7071 5.70711L17.7071 1.70711L16.2929 0.292893L12.2929 4.29289L13.7071 5.70711ZM10.2929 11.7071L12.2929 13.7071L13.7071 12.2929L11.7071 10.2929L10.2929 11.7071ZM13.7071 13.7071L17.7071 9.70711L16.2929 8.29289L12.2929 12.2929L13.7071 13.7071ZM0.292893 11.7071L2.29289 13.7071L3.70711 12.2929L1.70711 10.2929L0.292893 11.7071ZM3.70711 13.7071L7.70711 9.70711L6.29289 8.29289L2.29289 12.2929L3.70711 13.7071ZM2.70711 5.70711L4.70711 3.70711L3.29289 2.29289L1.29289 4.29289L2.70711 5.70711ZM4.70711 3.70711L6.70711 1.70711L5.29289 0.292893L3.29289 2.29289L4.70711 3.70711ZM6.70711 4.29289L4.70711 2.29289L3.29289 3.70711L5.29289 5.70711L6.70711 4.29289ZM4.70711 2.29289L2.70711 0.292893L1.29289 1.70711L3.29289 3.70711L4.70711 2.29289Z"
            fill="#8E9CBB"
          />
        </svg>
      </div>

      <div v-if="image" class="c-switcher-image" :style="{ 'background-image': `url(${image})` }"></div>

      <div
        v-if="type !== 'checkbox-icon'"
        class="c-switcher-label"
        :class="{
          'c-switcher-label_nowrap': nowrap,
          'c-switcher-label_active': localValue,
          'c-switcher-label_label': label && label.color && label.color === 'label',
        }"
      >
        <span v-if="label" v-html="label.text ? label.text : label"></span>

        <span v-if="subLabel" class="c-switcher-sublabel">{{ subLabel }}</span>
        <slot />
      </div>

      <div v-if="labelFullName" class="c-input-label-fullname">
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover',
            content: labelFullName,
            placement: 'bottom',
          }"
          size="iconic"
          icon="info"
          @click.stop
        />
      </div>

      <b-popover v-if="tooltip !== undefined" triggers="hover" placement="top" :target="`c-switcher-${_uid}`">
        {{ tooltip && !disabled ? (localValue ? tooltip.activeText : tooltip.notActiveText) : "" }}
        {{ tooltip && disabled ? tooltip.disabledText : "" }}
      </b-popover>
    </label>

    <div v-if="type === 'group'" class="c-switcher-group">
      <div
        v-for="item in items"
        :id="`c-switcher-group-item-${item.value}`"
        :key="item.value"
        class="c-switcher-group-item"
        :class="{
          'c-switcher-group-item_active': localValue === item.value,
          'c-switcher-group-item_iconic': item.icon,
          'c-switcher-group-item_bg_success': item.bg === 'success',
          'c-switcher-group-item_bg_error': item.bg === 'error',
        }"
        @click="localValue = item.value"
      >
        <b-popover v-if="item.tooltip" placement="top" triggers="hover" :target="`c-switcher-group-item-${item.value}`">
          {{ item.tooltip }}
        </b-popover>
        <div
          v-if="item.icon && item.icon === 'ruble'"
          width="9"
          height="11"
          style="text-align: center;width: 2.5rem;"
        >
          ฿
        </div>

        <svg
          v-if="item.icon && item.icon === 'percent'"
          width="12"
          height="13"
          viewBox="0 0 12 13"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.625 5.75C3.15625 5.75 2.71094 5.63281 2.3125 5.39844C1.89062 5.16406 1.58594 4.85938 1.35156 4.4375C1.11719 4.03906 1 3.59375 1 3.125C1 2.65625 1.11719 2.23438 1.35156 1.8125C1.58594 1.41406 1.89062 1.08594 2.3125 0.851562C2.71094 0.617188 3.15625 0.5 3.625 0.5C4.09375 0.5 4.51562 0.617188 4.9375 0.851562C5.33594 1.08594 5.66406 1.41406 5.89844 1.8125C6.13281 2.23438 6.25 2.65625 6.25 3.125C6.25 3.59375 6.13281 4.03906 5.89844 4.4375C5.66406 4.85938 5.33594 5.16406 4.9375 5.39844C4.51562 5.63281 4.09375 5.75 3.625 5.75ZM3.625 2C3.29688 2 3.03906 2.11719 2.82812 2.32812C2.59375 2.5625 2.5 2.82031 2.5 3.125C2.5 3.45312 2.59375 3.71094 2.82812 3.92188C3.03906 4.15625 3.29688 4.25 3.625 4.25C3.92969 4.25 4.1875 4.15625 4.42188 3.92188C4.63281 3.71094 4.75 3.45312 4.75 3.125C4.75 2.82031 4.63281 2.5625 4.42188 2.32812C4.1875 2.11719 3.92969 2 3.625 2ZM8.875 7.25C9.34375 7.25 9.76562 7.36719 10.1875 7.60156C10.5859 7.83594 10.9141 8.16406 11.1484 8.5625C11.3828 8.98438 11.5 9.40625 11.5 9.875C11.5 10.3438 11.3828 10.7891 11.1484 11.1875C10.9141 11.6094 10.5859 11.9141 10.1875 12.1484C9.76562 12.3828 9.34375 12.5 8.875 12.5C8.40625 12.5 7.96094 12.3828 7.5625 12.1484C7.14062 11.9141 6.83594 11.6094 6.60156 11.1875C6.36719 10.7891 6.25 10.3438 6.25 9.875C6.25 9.40625 6.36719 8.98438 6.60156 8.5625C6.83594 8.16406 7.14062 7.83594 7.5625 7.60156C7.96094 7.36719 8.40625 7.25 8.875 7.25ZM8.875 11C9.17969 11 9.4375 10.9062 9.67188 10.6719C9.88281 10.4609 10 10.2031 10 9.875C10 9.57031 9.88281 9.3125 9.67188 9.07812C9.4375 8.86719 9.17969 8.75 8.875 8.75C8.54688 8.75 8.28906 8.86719 8.07812 9.07812C7.84375 9.3125 7.75 9.57031 7.75 9.875C7.75 10.2031 7.84375 10.4609 8.07812 10.6719C8.28906 10.9062 8.54688 11 8.875 11ZM10.1875 0.5C10 0.5 9.83594 0.59375 9.74219 0.734375L1.11719 11.6094C0.976562 11.7969 0.953125 12.0078 1.07031 12.1953C1.16406 12.4062 1.32812 12.5 1.5625 12.5H2.35938C2.54688 12.5 2.6875 12.4297 2.80469 12.2656L11.4062 1.39062C11.5234 1.20312 11.5234 1.01562 11.4297 0.804688C11.3125 0.617188 11.1484 0.5 10.9375 0.5H10.1875Z"
          />
        </svg>

        <svg
          v-if="item.icon && item.icon === 'charts'"
          width="17"
          height="14"
          viewBox="0 0 17 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 2C13 1.44772 13.4477 1 14 1H15C15.5523 1 16 1.44772 16 2V12C16 12.5523 15.5523 13 15 13H14C13.4477 13 13 12.5523 13 12V2Z"
            stroke="#8E9CBB"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M7 2C7 1.44772 7.44772 1 8 1H9C9.55228 1 10 1.44772 10 2V12C10 12.5523 9.55228 13 9 13H8C7.44772 13 7 12.5523 7 12V2Z"
            stroke="#8E9CBB"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M1 2C1 1.44772 1.44772 1 2 1H3C3.55228 1 4 1.44772 4 2V12C4 12.5523 3.55228 13 3 13H2C1.44772 13 1 12.5523 1 12V2Z"
            stroke="#8E9CBB"
            stroke-width="2"
            stroke-linejoin="round"
          />
        </svg>

        <svg
          v-if="item.icon && item.icon === 'list'"
          width="17"
          height="12"
          viewBox="0 0 17 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 11H1M16 6H1M16 1H1"
            stroke="#8E9CBB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <div class="c-switcher-group-item-label" v-html="item.label"></div>
      </div>
    </div>

    <error-feedback v-if="error" :text="error" />
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";

export default {
  name: "c-switcher",
  components: {
    "c-button": Button,
    ErrorFeedback,
  },

  props: [
    "label",
    "subLabel",
    "labelFullName",
    "value",
    "id",
    "type",
    "items",
    "nowrap",
    "model2",
    "image",
    "disabled",
    "tooltip",
    "multi",
    "checked",
    "invalid",
    "error",
    "middlePosition"
  ],

  data() {
    return {
      localValue: this.value ? this.value : false,
    };
  },

  computed: {
    internalChecked: {
      get() {
        return this.value;
      },
      set(checked) {
        this.$emit("input", checked);
      },
    },
  },

  watch: {
    localValue(value) {
      this.$emit("input", value);
    },
    value(value) {
      this.localValue = value;
    },
  },

  methods: {
    toggle() {
      if (!this.type) {
        this.localValue = !this.localValue;
      }
    },

    mousedown(e) {
      this.$emit("mousedown", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-switcher {
  display: flex;
  align-items: center;
  cursor: pointer;

  &-width-inherit {
    width: 100%;
    max-width: 100%;

    &-cursor {
      cursor: pointer;
    }
  }

  &_disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &-indicator {
    width: 38px;
    height: 20px;
    background: $line;
    border-radius: 10px;
    transition: 0.2s;
    align-items: center;
    display: flex;
    position: relative;
    flex-shrink: 0;

    &-circle {
      width: 16px;
      height: 16px;
      background: white;
      border-radius: 50%;
      transition: 0.2s;
      left: 2px;
      position: absolute;
    }

    &_active {
      background: $link;
      justify-content: flex-end;

      .c-switcher-indicator-circle {
        left: 20px;
      }
    }
  }

  &-label {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
    line-height: 14px;
    margin-left: 10px;
    transition: 0.2s;
    color: black;

    &_nowrap {
      white-space: nowrap;
    }

    // &_label {
    //   color: $color-label;
    // }
  }

  &-sublabel {
    display: block;
    font-size: 13px;
    color: #8E9CBB;
    margin-top: 4px;
  }

  .c-input-label-fullname {
    margin-left: 8px;
  }

  &-input {
    display: none;

    &:checked + .c-switcher-checkbox {
      background: $color-primary;
      border-color: $color-primary;

      & + .c-switcher-label {
        // color: black;
      }
    }
  }

  &-image {
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    margin-left: 12px;
    border-radius: 50%;
    background: {
      size: cover;
      position: center;
    }
  }

  &-checkbox {
    width: 18px;
    height: 18px;
    transition: 0.2s;
    border-radius: 3px;
    border: 1px solid #bfc9e0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-shrink: 0;

    &-icon {
      fill: white;

      &_check {
        width: 11px;
        height: 8px;
        position: absolute;
        top: 4px;
        left: 3px;
      }
    }
  }

  &_checkbox_type_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 16px;
    height: 12px;

    &_disabled {
      fill: $color-button-border;
    }

    &_active path {
      fill: $color-pink;
    }
  }

  &-group {
    display: inline-flex;
    border-radius: 15px;
    border: 1px solid $color-button-border;
    box-sizing: border-box;

    &-item {
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-left: 1px solid $color-button-border;
      transition: 0.2s;
      cursor: pointer;
      padding: 0 20px;

      &_iconic {
        width: 35px;
        padding: 0;
      }

      &-label {
        font: {
          size: 12px;
          weight: 500;
        }
        color: $color-label;
        transition: 0.2s;
      }

      svg {
        fill: $color-primary;
        transition: 0.2s;
      }

      &:first-child {
        border-left: none;
        border-radius: 15px 0 0 15px;
      }

      &:last-child {
        border-radius: 0 15px 15px 0;
      }

      &_active {
        background: $color-bg;

        &.c-switcher-group-item_bg_success {
          background: $color-success-light;
        }

        &.c-switcher-group-item_bg_error {
          background: $color-error-light;
        }

        svg {
          fill: $color-font;
        }

        .c-switcher-group-item-label {
          color: $color-font;
        }
      }
    }
  }

  &-invalid {
    .c-switcher-checkbox {
      border-color: $color-secondary;
    }
  }
}
</style>
